// extracted by mini-css-extract-plugin
module.exports = {"performance":"LoadingIndicator_performance__3iHpa","rotation":"LoadingIndicator_rotation__1dkf4"};